<div class="footer">
  <hr>
  &nbsp;{{CopyrightMessage}}
</div>
